export const NETWORK_CONFIG = { response_formatter: api_response_formatter };

export const AUTH_CONFIG = {
  auth_token_response_formatter: auth_token_response_formatter,
};

export const APP_CONFIG = {
  NETWORK_CONFIG,
  AUTH_CONFIG,
};

export default APP_CONFIG;

function api_response_formatter(response_data) {
  response_data = JSON.parse(response_data);
  return {
    data: response_data?.data,
    meta: {
      ...response_data?.meta,
      page_data: response_data?.results ? { count: response_data?.count } : {},
    },
    raw: response_data?.results ? response_data?.results : response_data,
    message: response_data?.message,
    error_message: response_data?.detail?.error ?? response_data,
    status: response_data?.status
      ? response_data?.status
      : response_data?.detail?.status,
    validation_errors: response_data?.validation_errors,
  };
}

function auth_token_response_formatter(response_data) {
  let { accessToken, refreshToken } = response_data;

  return {
    access_token: accessToken,
    refresh_token: refreshToken,
  };
}
